export default __webpack_public_path__ + "static/media/share-02.deec7603.png";